import React from "react";

import PoweredByDeex from "../PoweredByDeex";

type Props = {
  children: React.ReactNode;
  /** Column width — payment forms read better narrow, lists want more room. */
  width?: "narrow" | "wide";
};

/**
 * Frame for every customer-facing link page. It owns three things so the
 * individual pages don't have to re-solve them: the tinted backdrop, a centred
 * column that stays comfortable from 320px up, and a footer that sits at the
 * bottom of the *viewport* on short pages rather than stranding itself under a
 * screenful of empty grey.
 */
const CustomerPageShell = ({ children, width = "narrow" }: Props) => (
  <div className="relative flex min-h-[100dvh] w-full flex-col overflow-hidden bg-[#F4F6F8] font-manrope">
    {/* Soft wash behind the header so the logo has something to sit on. */}
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-0 top-0 h-[320px] bg-[radial-gradient(120%_100%_at_50%_0%,rgba(11,132,203,0.10)_0%,rgba(11,132,203,0)_70%)]"
    />

    <main className="relative flex flex-1 justify-center px-4 pb-10 pt-10 mds:pt-14">
      <div className={width === "wide" ? "w-full max-w-[560px]" : "w-full max-w-[460px]"}>
        {children}
      </div>
    </main>

    <PoweredByDeex className="relative pb-10" />
  </div>
);

export default CustomerPageShell;
